<template>
  <iframe
    v-if="$q.screen.width >= 600 && !$q.platform.is.mobile && !$q.platform.is.nativeMobile"
    :src="file.signed_url"
    class="full-width full-height no-border bg-grey-4"
  />
  <div
    v-else
    class="full-width full-height flex flex-center"
  >
    <q-btn
      no-caps
      outline
      @click="goToHref(file.signed_url, true)"
    >
      <q-item-wrapper
        v-if="$q.platform.is.ios"
        icon="mdi-apple-safari"
        icon-size="2.5em"
        color="white"
        dark
        label-class="text-left text-bold"
        label="Open PDF in Safari"
        caption-class="text-left"
        caption="Tap to open this PDF in Safari"
      />
      <q-item-wrapper
        v-else
        icon="mdi-download"
        icon-size="2.5em"
        color="white"
        dark
        label-class="text-left text-bold"
        label="Download PDF"
        caption-class="text-left"
        caption="Download this PDF to your device to view it"
      />
    </q-btn>
  </div>
</template>

<script>
import fileMixin from './mixin'

export default {
  mixins: [fileMixin]
}
</script>
